module.exports = __webpack_public_path__ + "media/images/WFC_Landscape_White_w_0-bf77a0eff400276a1d1be62c0f9275ed.svg";